import { theme } from 'antd';
import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
};

const { useToken } = theme;

const PictureIcon: FC<Props> = ({ width = 18, height = 18 }) => {
  const { token } = useToken();

  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Image">
        <path
          id="Vector"
          d="M15.1875 2.8125H2.8125C2.51413 2.8125 2.22798 2.93103 2.017 3.142C1.80603 3.35298 1.6875 3.63913 1.6875 3.9375V14.0625C1.6875 14.3609 1.80603 14.647 2.017 14.858C2.22798 15.069 2.51413 15.1875 2.8125 15.1875H15.1875C15.4859 15.1875 15.772 15.069 15.983 14.858C16.194 14.647 16.3125 14.3609 16.3125 14.0625V3.9375C16.3125 3.63913 16.194 3.35298 15.983 3.142C15.772 2.93103 15.4859 2.8125 15.1875 2.8125ZM15.1875 3.9375V11.1621L13.3545 9.32977C13.25 9.22527 13.126 9.14238 12.9894 9.08583C12.8529 9.02928 12.7066 9.00017 12.5589 9.00017C12.4111 9.00017 12.2648 9.02928 12.1283 9.08583C11.9918 9.14238 11.8678 9.22527 11.7633 9.32977L10.357 10.736L7.26328 7.64227C7.05232 7.43145 6.76629 7.31302 6.46805 7.31302C6.16981 7.31302 5.88377 7.43145 5.67281 7.64227L2.8125 10.5026V3.9375H15.1875ZM2.8125 12.0938L6.46875 8.4375L12.0938 14.0625H2.8125V12.0938ZM15.1875 14.0625H13.6849L11.1537 11.5312L12.5599 10.125L15.1875 12.7533V14.0625ZM10.125 7.03125C10.125 6.86437 10.1745 6.70124 10.2672 6.56249C10.3599 6.42373 10.4917 6.31559 10.6459 6.25173C10.8 6.18787 10.9697 6.17116 11.1334 6.20371C11.297 6.23627 11.4474 6.31663 11.5654 6.43463C11.6834 6.55263 11.7637 6.70297 11.7963 6.86664C11.8288 7.03031 11.8121 7.19996 11.7483 7.35414C11.6844 7.50831 11.5763 7.64009 11.4375 7.7328C11.2988 7.82552 11.1356 7.875 10.9688 7.875C10.745 7.875 10.5304 7.78611 10.3721 7.62787C10.2139 7.46964 10.125 7.25503 10.125 7.03125Z"
          fill={token.colorPrimary}
        />
      </g>
    </svg>
  );
};

export default PictureIcon;
